var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-checkbox", class: _vm.getVariant("input-checkbox") },
    [
      _c("input", {
        attrs: {
          id: _vm.id,
          type: _vm.type,
          name: _vm.id,
          readonly: _vm.disabled,
          required: _vm.required
        },
        domProps: { checked: _vm.value },
        on: {
          change: function($event) {
            return _vm.updateValue($event.target.checked)
          }
        }
      }),
      _c("label", { attrs: { for: _vm.id } }, [
        _c("span"),
        _vm._v("\n    " + _vm._s(_vm.$t(_vm.label)) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05ce4ef2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ce4ef2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/input-checkbox-view.vue
// module id = 274
// module chunks = 63 67